import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoLoaderService implements TranslocoLoader {
  getTranslation(lang: string): Promise<Translation> {
    return fetch(`/i18n/${lang}.json`).then((r) => r.json());
  }
}
